import React from 'react';
import { PARAMS } from "../../../../config";
const backgroundRed = { background: 'red' };

const Row = ({ row, quality }) => {
    let td = getValues(row);

    if(quality) td.push(<td key={'rD'}>{row.rD}</td>);

    return (
        <tr>
            <td>{row.h}</td>
            <td>{row.a}</td>
            <td>{row.s}</td>
            {td}
        </tr>
    );
};

function getValues(row) {
    return PARAMS.map(paramObj => {
        const param = paramObj[0];
        const paramType = paramObj[2];
        const value = row[param];

        const styles = paramType === 'roi' && value < 0 ? backgroundRed : {};

        return(<td style={styles} key={param}>{value}</td>);
    });
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdKernelHourly/components/Table/components/Row/index.js